import React from "react";
import { useTable } from "../../Components/useTable";

const ProfileTagUsersList = () => {
  const type = "Assign Profile Tags";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "assignUsername", numeric: false, label: "User Name" },
    { id: "assignUserImage", numeric: false, label: "User Image" },
    { id: "tagName", numeric: false, label: "Tag Name" },
    { id: "tagImage", numeric: false, label: "Tag Image" },
    { id: "tagstatus", numeric: false, label: "Status" },
    { id: "created", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default ProfileTagUsersList;
